import { TokenListMetadata } from "@bridgesplit/abf-sdk";
import { ProgressBar, Row, Text, Column, TooltipText } from "@bridgesplit/ui";
import { COPY } from "app/constants";
import { formatUsd } from "@bridgesplit/utils";
import { NeighboringCurrencyDisplay } from "app/components/common";

export function SuppliedProgressBar({
    principalSupplied,
    principalLimit,
    principalUsdPrice,
    theme,
    showBothCurrencyValues,
    metadata
}: {
    principalSupplied: number;
    principalLimit: number;
    principalUsdPrice: number;
    theme: string | undefined;
    showBothCurrencyValues: boolean;
    metadata?: TokenListMetadata;
}) {
    if (!principalLimit || !principalUsdPrice) {
        return null;
    }

    const percentSupplied = (principalSupplied / principalLimit) * 100;

    return (
        <Column spacing={1}>
            <Row spaceBetween>
                <Text variant="body2" color="caption">
                    Supplied
                </Text>
                {showBothCurrencyValues ? (
                    <NeighboringCurrencyDisplay metadata={metadata} amount={principalSupplied} />
                ) : (
                    <Text variant="body2" color="caption" translate="no">
                        {formatUsd(principalUsdPrice * principalSupplied)}
                    </Text>
                )}
            </Row>
            <ProgressBar
                sx={{
                    width: "100%",
                    height: "10px",
                    borderRadius: "5px",
                    margin: "4px 0"
                }}
                bgColor={theme}
                value={percentSupplied}
            />
            <Row spaceBetween>
                <Row spacing={0.5}>
                    <Text variant="body2" color="caption">
                        Limit
                    </Text>
                    <TooltipText
                        variant="body2"
                        tooltipProps={{ placement: "bottom" }}
                        icon={true}
                        helpText={COPY.GENESIS_VAULT_SUPPLY_DETAILS}
                    />
                </Row>
                {showBothCurrencyValues ? (
                    <NeighboringCurrencyDisplay metadata={metadata} amount={principalLimit} />
                ) : (
                    <Text variant="body2" color="caption" translate="no">
                        {formatUsd(principalUsdPrice * principalLimit)}
                    </Text>
                )}
            </Row>
        </Column>
    );
}
